<template>
  <div class="c-card c-card--primary">
    <p v-if="$store.state.displayTimers.error" role="alert">{{ $store.state.displayTimers.error }}</p>
    <div class="o-layout">
      <div class="o-layout__item u-margin-bottom-small" v-for="item in timers" :key="item.id">
        <timer :timer="item" :ts="ts" />
      </div>
      <div class="o-layout__item">
        <timer v-if="adding" :key="$route.params.disciplineId" :ts="ts" @close="adding = false" />
        <sceButton v-else icon="svg-symbols.svg#plus" @click="adding = true" label="timer.add"
                   class="c-button__icon--primary c-button--primary c-button--small" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'timers',
  components: {timer: require('./timer.vue').default},
  props: ['ts'],
  data: function() { return {adding: false}; },
  computed: {
    timers: function() {
      return this.$store.state.displayTimers.items.filter(timer =>
        timer.eventDisciplineId === this.$route.params.disciplineId);
    },
  },
};
</script>
